import { Plus, X } from "lucide-react"

import { Boton } from "@/componentes/ui/Boton"

import type { ActividadRuta } from "./cargo"

/**
 * La hoja de ruta del puesto (28/10, minuta «Estructura de la Compañía»): la inducción de
 * quien llega, actividad por actividad, con el día desde su ingreso y quién lo acompaña.
 * Cada persona del cargo marca su avance en Talento Humano → Ingresos.
 */
export function HojaDeRuta({
  actividades,
  onCambiar,
}: {
  actividades: ActividadRuta[]
  onCambiar: (a: ActividadRuta[]) => void
}) {
  const poner = (i: number, cambio: Partial<ActividadRuta>) =>
    onCambiar(actividades.map((a, j) => (j === i ? { ...a, ...cambio } : a)))
  return (
    <section className="mt-4 space-y-2">
      <h3 className="rotulo">Hoja de ruta del puesto</h3>
      <p className="text-xs" style={{ color: "var(--fg-muted)" }}>
        La inducción de quien llega: qué hace cada día desde su ingreso y quién lo acompaña. Se
        ordena por día al guardar.
      </p>
      {actividades.map((a, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: actividades editables sin identidad propia; los campos son controlados.
        <div key={i} className="grid gap-2 sm:grid-cols-[5rem_1fr_12rem_auto]">
          <input
            aria-label="Día desde el ingreso"
            type="number"
            min={1}
            max={365}
            className="campo"
            value={a.dia}
            onChange={(e) => poner(i, { dia: Number(e.target.value) })}
          />
          <input
            aria-label="Actividad"
            placeholder="Conocer el circuito de órdenes de pago"
            className="campo"
            value={a.actividad}
            onChange={(e) => poner(i, { actividad: e.target.value })}
          />
          <input
            aria-label="Quién acompaña"
            placeholder="Quién acompaña"
            className="campo"
            value={a.responsable}
            onChange={(e) => poner(i, { responsable: e.target.value })}
          />
          <Boton
            tamano="sm"
            aria-label="Quitar actividad"
            onClick={() => onCambiar(actividades.filter((_, j) => j !== i))}
          >
            <X size={14} />
          </Boton>
        </div>
      ))}
      <Boton
        tamano="sm"
        onClick={() =>
          onCambiar([
            ...actividades,
            { dia: (actividades.at(-1)?.dia ?? 0) + 1, actividad: "", responsable: "" },
          ])
        }
      >
        <Plus size={14} /> Añadir actividad
      </Boton>
    </section>
  )
}
